import script from "./FilterSegments.vue?vue&type=script&setup=true&lang=ts"
export * from "./FilterSegments.vue?vue&type=script&setup=true&lang=ts"

import "./FilterSegments.vue?vue&type=style&index=0&id=a1817db4&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a1817db4"]])

export default __exports__